import { patchBlock } from "../service/patchBlock";

export const changeImageProduct = async (
    productId: string, 
    imageId: string, 
    newImage: File 
): Promise<{
    block: string,
    isError: boolean
}> => {
    const imgData = new FormData();
    let block: string = "";
    let isError: boolean = false;

    if(newImage) {
        imgData.append("filename" , newImage);
        const { block, isError } = await patchBlock(
            `/branch/products/photos/update?active=true&productId=${productId}&id=${imageId}`, 
            imgData
        );

        return {
            block: block, 
            isError: isError
        }
    }

    return {
        isError: isError,
        block: block
    }



}